
import { computed, defineComponent, ref } from 'vue';
import MissionCard from './MissionCard.vue';
import breakpoints from '../utils/breakpoints';
import { Info as InfoIcon, ChevronLeft as CarouselPrev, ChevronRight as CarouselNext } from '@vicons/fa';
import { Mission, missionList } from '@/data/missions';

export default defineComponent({
  name: 'Mission',
  components: { MissionCard, InfoIcon, CarouselPrev, CarouselNext },
  setup () {
    const missions = ref<Mission[]>(missionList);
    const missionsCount = ref(0);
    const missionSpan = computed(() => {
      if (breakpoints.xs.matches || breakpoints.s.matches) return 12;
      if (breakpoints.l.matches || breakpoints.m.matches) return 6;
      return 6;
    });
    const cardsPerSlide = computed(() => 12/missionSpan.value);
    const totalSlides = computed(() => Math.ceil(missionsCount.value / cardsPerSlide.value));
    const slideMissions = computed(() => {
      const slideAux: Mission[][] = [];
      for (let i = 0; i < totalSlides.value; i++) {
        slideAux.push([]);
        for (let j = 0; j < cardsPerSlide.value; j++) {
          slideAux[i].push(missions.value[cardsPerSlide.value * i + j]);
        }
      }
      return slideAux;
    });

    missionsCount.value = missions.value.length;
    return {
      breakpoints,
      missions,
      missionSpan,
      cardsPerSlide,
      totalSlides,
      slideMissions
    };
  }
});
